import PromotionMarkup from './PromotionMarkup'

export default PromotionMarkup